import { Component, OnInit, QueryList, ViewChildren, inject, input, output } from "@angular/core";
import { IInteraction, NotificationService } from "../../../../core-ui";
import { InteractionService } from "../../../services";

import { TranslateService } from "@ngx-translate/core";
import {
  AnalyticsService,
  GenericErrorHandler,
} from "../../../../core-ui/services";
import { IShareLinkAction } from "../share-link.component";
import {
  IMenuItemContainer,
  MENU_ITEM_CONTAINER_TOKEN,
  MenuItemComponent,
} from "../../../../modules/shared/components";

@Component({
  selector: "app-share-link-chat",
  templateUrl: "./chat.component.html",
  styleUrls: ["./chat.component.scss"],
  providers: [
    {
      provide: MENU_ITEM_CONTAINER_TOKEN,
      useExisting: ShareLinkChatComponent,
    },
  ],
  standalone: false,
})
export class ShareLinkChatComponent
  implements OnInit, IShareLinkAction, IMenuItemContainer
{
  private interactionService = inject(InteractionService);
  private analyticsService = inject(AnalyticsService);
  private errorHandler = inject(GenericErrorHandler);
  private translate = inject(TranslateService);
  private notification = inject(NotificationService);

  readonly interaction = input<IInteraction>(undefined);
  readonly link = input<string>(undefined);

  readonly completed = output<void>();
  readonly openChange = output<boolean>();

  @ViewChildren(MenuItemComponent) menuItems: QueryList<MenuItemComponent>;

  ngOnInit(): void {}

  getMenuItems(): MenuItemComponent[] {
    return this.menuItems.toArray();
  }

  shareLink() {
    try {
      const interaction = this.interaction();
      this.interactionService.postMessageToInteraction(
        interaction,
        this.link()
      );
      interaction.setCustomerInvited(true);
      this.analyticsService.trackInvitationSent(interaction);
      this.notification.show("auvious", {
        body: this.translate.instant("Link sent to chat."),
      });
      // this.renewCustomerLink();
      this.completed.emit();

      // this.shareOpen = false;
      this.openChange.emit(false);
    } catch (ex) {
      this.errorHandler.handleError(ex);
    }
  }
}
